import dayjs from "dayjs";
import { enums } from "./enums";
import regexPattern from "./regexPattern";
import relativeTime from "dayjs/plugin/relativeTime";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(relativeTime);

//Currency formatter, The currency will format without decimal.
const formatted = new Intl.NumberFormat("en-IN", {
  style: "currency",
  currency: "INR",
  maximumFractionDigits: 0,
});

const currencyFormatter = (number) => {
  // console.log("This currencyFormatter ()");
  return formatted.format(number);
};
export default currencyFormatter;

//Currency formatter, The currency will format with decimal.
const formattedWithDecimal = new Intl.NumberFormat("en-IN", {
  style: "currency",
  currency: "INR",
  maximumFractionDigits: 2,
});

export const currencyFormatterWithDecimal = (number) => {
  // if (number >= 10000000) return `₹${(number / 10000000).toFixed(1)}Cr`;
  // if (number >= 100000) return `₹${(number / 100000).toFixed(1)}Lacs`;
  // if (number >= 1000) return `₹${(number / 1000).toFixed(1)}K`;
  return formattedWithDecimal.format(number);
};
export const capitalizeFirstLetter = (sentence) => {
  // console.log("This capitalizeFirstLetter ()");
  if (!sentence) return "";
  return sentence
    .split(" ")
    .map((word) => {
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(" ");
};

export const replaceSpaceToUnderScore = (sentence) => {
  if (sentence === undefined || sentence === null) return "";
  return (sentence = sentence.toLowerCase().replaceAll(/\s+/g, "_"));
};

export const replaceUnderScoreToSpace = (sentence) => {
  if (sentence === undefined || sentence === null) return "";
  return sentence.toLowerCase().replaceAll(/_/g, " ");
};

export const replaceSpecialCharFromNumber = (value) => {
  if (value === undefined || value === null) return "";
  return value
    .split(" ")
    .slice(1)
    .join("")
    .replace(regexPattern.replaceSpecialChar, "");
};

export const arrangedSearchedProducts = (data) => {
  if (!data) {
    return;
  }
  return data.map((item) => {
    const name = item.values.name && item.values.name[0].data;
    const description =
      item.values.description && item.values.description[0].data;
    const img = item.values.photo && item.values.photo[0].data;
    const mrp = item.values.mrp && item.values.mrp[0].data[0].amount;
    const piecesInCarton = item.values.packs_of && item.values.packs_of[0].data;
    const variantMrp = item.values.condition && item.values.condition[0].data;
    const imageToken = item?.akeneo_token;
    const imageBaseUrl = item?.akeneo_image_base_url;
    const created = item?.created;

    return {
      id: item.uuid && item.uuid,
      name: name,
      image: img,
      description: description,
      mrp: mrp,
      piecesInCarton: piecesInCarton,
      variantMrp: variantMrp,
      priceBookStatus: item.price_book_status && item.price_book_status,
      thumbnail_url: img,
      quantity_per_ctn: piecesInCarton,
      imageToken: imageToken,
      imageBaseUrl: imageBaseUrl,
      created: created,
    };
  });
};

export const formatePrice = (value) => {
  if (!value) {
    return;
  }

  if (isNaN(value) && isNaN(parseFloat(value))) {
    return;
  }
  if (/^\d*\.?\d*$/.test(value)) {
    // const numericValue = value ? parseFloat(value) : 0;
    // console.log("Shivansh ", typeof numericValue);
    // return numericValue;

    const roundedValue = String(value).endsWith(".")
      ? String(value)
      : Math.round(parseFloat(value) * 100) / 100;
    return roundedValue;
  }

  // const roundedValue = String(value).endsWith(".")
  //   ? String(value)
  //   : Math.round(parseFloat(value) * 100) / 100;
  // return roundedValue;
  return;
};

export const convertIntoPercent = (current, total) => {
  if (
    current === null ||
    current === undefined ||
    total === null ||
    total === undefined
  ) {
    return 0;
  }
  const percent = 100 - (current / total) * 100;
  return percent.toFixed(2);
};

export const getCompanyRate = (mrp, discount = 0) => {
  if (!mrp || mrp <= 0) {
    return 0;
  }
  discount = parseFloat(discount);
  const denominator = 1 + discount / 100;

  if (denominator === 0) {
    return 0; // Prevent division by zero
  }
  return parseFloat(mrp / denominator).toFixed(2);
};

export const getCompanyDiscountPercent = (companyRate, mrp) => {
  if (!companyRate || !mrp || companyRate <= 0 || mrp <= 0) {
    return 0;
  }
  const mrpByCompanyRate = mrp / companyRate;
  const discount = (mrpByCompanyRate - 1) * 100;
  return parseFloat(discount.toFixed(2));
};

export const calculateAskingPrice = (mrp, discount = 0) => {
  if (!mrp || mrp <= 0) {
    return 0;
  }
  if (discount) {
    discount = parseFloat(discount);
  }
  return mrp * (1 - discount / 100);
};

export const displayPrice = (
  quantityType,
  quantityPerCtn,
  mrp,
  askingPrice
) => {
  if (!quantityPerCtn || !quantityType || !mrp) {
    return 0;
  }
  if (quantityType === enums.QUANTITY_TYPE.CTN) {
    return quantityPerCtn * calculateAskingPrice(mrp, askingPrice);
  }
  return calculateAskingPrice(mrp, askingPrice);
};

export const formateQuantity = (value) => {
  if (!value || (isNaN(value) && isNaN(parseFloat(value)))) {
    return;
  }
  if (/^[1-9]+[0-9]*$/.test(value)) {
    return value;
  }
  return;
};

export const calculateNetPrice = (
  priceType,
  value,
  quatityType,
  quantityPerCtn,
  mrp,
  companyRate
) => {
  if (
    !value === undefined ||
    value === null ||
    !quantityPerCtn ||
    !mrp ||
    !priceType ||
    !quatityType
  ) {
    return "NA";
  }
  if (priceType === enums.PRICE_TYPE.NET_DISCOUNT) {
    return displayPrice(quatityType, quantityPerCtn, mrp, value);
  }
  if (priceType === enums.PRICE_TYPE.ADD_DISCOUNT) {
    const base = (companyRate / quantityPerCtn) * (1 - value / 100);

    return quatityType === enums.QUANTITY_TYPE.PIECE
      ? base
      : base * quantityPerCtn;
  }
  // if (priceType === enums.PRICE_TYPE.ADD_DISCOUNT) {
  //   const newvalue = (companyRate / quantityPerCtn) * (1 - value / 100);
  //   return newvalue * quantityPerCtn;
  // }
  if (priceType === enums.PRICE_TYPE.NET_PRICE) {
    return value;
  }
};

export const calculateUnitPrice = (
  type,
  price,
  companyRateType,
  mrp,
  piecePerCtn,
  discountType,
  discount = 0,
  quantityType
) => {
  if (!type) return 0;
  if (type === "company_rate") {
    let companyRateInr = price;
    if (companyRateType === "discount") {
      companyRateInr = getCompanyRate(mrp * piecePerCtn, price);
    }
    return calculateAskingPrice(companyRateInr, discount);
  }

  if (discountType === "net_price") {
    return price;
  }
  let discountInr = calculateAskingPrice(mrp, price);
  if (quantityType && quantityType === "ctn") {
    return discountInr * piecePerCtn;
  }
  return discountInr;
};

export const formatAddress = (obj) => {
  if (!obj || typeof obj !== "object") return "";

  const keys = [
    "address_line1",
    "address_line2",
    "city",
    "gov_district_name",
    "country",
    "postal_area",
  ];

  // Extract and format values dynamically
  const values = keys
    .map((key) => {
      const value = obj[key];
      return value
        ? key === "postal_area"
          ? `(${value})`
          : capitalizeFirstLetter(value)
        : null;
    })
    .filter(Boolean);

  return values.join(", ");
};

export const privilegesFormatter = (privileges) => {
  if (!privileges) return;
  return privileges?.map(({ __typename, roles, ...module }) => ({
    ...module,
    roles: roles?.map(({ __typename, actions, ...role }) => ({
      ...role,
      actions: actions?.map(
        ({ __typename, associated_actions, ...action }) => ({
          ...action,
          associated_actions: associated_actions?.map(
            ({ __typename, ...associated_action }) => ({
              ...associated_action,
            })
          ),
        })
      ),
    })),
  }));
};

export const handleFilterClick = (setFilters, key, value) => {
  setFilters((prevFilters) => {
    if (Array.isArray(value) && value.length === 0) {
      // Remove the key if value is an empty array
      const updatedFilters = { ...prevFilters };
      delete updatedFilters[key];
      return updatedFilters;
    }

    return {
      ...prevFilters,
      [key]: value, // Dynamically add/update key-value pair
    };
  });
};

export const getFormattedDateWithOffset = (date = new Date()) => {
  const offsetMinutes = date.getTimezoneOffset();
  const sign = offsetMinutes > 0 ? "-" : "+";
  const hours = String(Math.floor(Math.abs(offsetMinutes) / 60)).padStart(
    2,
    "0"
  );
  const minutes = String(Math.abs(offsetMinutes) % 60).padStart(2, "0");

  return `${sign}${hours}:${minutes}`;
};

export const dateFormatter = (date) => {
  if (!date) return "NA";
  const currentYear = dayjs().year();
  const selectedYear = dayjs(date).year();

  return selectedYear === currentYear
    ? dayjs(date).format("DD-MMM")
    : dayjs(date).format("DD-MMM-YY");
};

export const titleCase = (val) => {
  return String(val).charAt(0).toUpperCase() + String(val).slice(1);
};

export const getTimeAgo = (
  createdAt,
  userTimezone = dayjs.tz.guess()
) => {
  // Return empty string if timestamp is missing
  if (!createdAt) return "";

  // Get current time in user's timezone
  const now = dayjs().tz(userTimezone);

  // Convert UTC timestamp to user's timezone
  const time = dayjs.utc(createdAt).tz(userTimezone);

  // Calculate difference in years
  const diffYears = now.diff(time, "year");
  if (diffYears > 0) return `${diffYears}y`;

  // Calculate difference in months (after years check)
  const diffMonths = now.diff(time, "month");
  if (diffMonths > 0) return `${diffMonths}m`;

  // Calculate difference in days
  const diffDays = now.diff(time, "day");

  // If exactly one day ago
  if (diffDays === 1) return "Yesterday";

  // If more than one day ago
  if (diffDays > 1) return `${diffDays}d`;

  // Calculate difference in hours
  const diffHours = now.diff(time, "hour");

  // If within the last 24 hours
  if (diffHours >= 0 && diffHours < 24) return "Today";

  // Fallback (future dates or edge cases)
  return "";
};

export const getRelativeTime = (createdAt) => {
  // If no timestamp provided, return empty string
  if (!createdAt) return "";

  // Use dayjs's fromNow() method to get human-readable relative time
  // Examples: "a few seconds ago", "2 minutes ago", "3 hours ago", "2 days ago"
  return dayjs(createdAt).fromNow();
};
